/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  customerId,
  customerRunnerTicketAddonId,
  customerRunnerTicketHookId,
  dealCompiler,
  dealId,
  isIntentionallyRepeating,
  isMarkedForAuto,
  isPartialAllowed,
  locale,
  note,
  objectId,
  rawFile,
  systemGameId,
  type,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  bypassDealById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  cancelDealById: {
    properties: {
      params: {
        properties: {
          compositeKey,
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  createDealBySystemGameId: {
    properties: {
      body: {
        properties: {
          compiler: dealCompiler,
          customerId,
          customerRunnerTicketAddonId,
          customerRunnerTicketHookId,
          isIntentionallyRepeating,
          isMarkedForAuto,
          isPartialAllowed,
          note,
          rawFile,
        },
        required: [
          'compiler',
          'customerId',
          'customerRunnerTicketAddonId',
          'customerRunnerTicketHookId',
          'isIntentionallyRepeating',
          'isPartialAllowed',
          'note',
          'rawFile',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  editDealById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  getDealById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDealReceipt: {
    properties: {
      params: {
        properties: {
          dealId,
        },
        required: ['dealId'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDealsBySystemGameId: {
    properties: {
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  printDealReceipt: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          dealId,
        },
        required: ['dealId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  processDealById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  restoreDealById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  shareDealReceipt: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          dealId,
        },
        required: ['dealId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  updateDealById: {
    properties: {
      body: {
        properties: {
          note,
        },
        required: ['note'],
        type: 'object',
      },
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
};
